import { AlertProps, AlertTitle, Alert, CircularProgress } from '@mui/material';

interface LoadingAlertProps extends AlertProps {
  title?: string;
}

const LoadingAlert = ({ title, children, ...others }: LoadingAlertProps) => (
  <Alert icon={<CircularProgress color="inherit" />} {...others}>
    <AlertTitle>{title}</AlertTitle>
    {children}
  </Alert>
);

export default LoadingAlert;
